import React from "react";
import PropTypes from "prop-types";
import { OrderHistoryItem } from "../Components/OrderHistoryItem/OrderHistoryItem";
import styles from "./OrderHistoryList.module.css";

export function OrderHistoryList({ orders = [], onOrderView }) {
  const safeOrders = Array.isArray(orders) ? orders : [];
  const hasOrders = safeOrders.length > 0;

  const resolveOnView = (order, index) => {
    if (typeof order?.onView === "function") {
      return order.onView;
    }

    if (typeof onOrderView === "function") {
      return () => onOrderView(order, index);
    }

    return undefined;
  };

  return (
    <section className={styles.listContainer}>
      <div className={styles.listContent}>
        <header
          className={styles.listHeader}
          aria-label="Order history columns"
        >
          <span className={`${styles.headerCell} ${styles.shipmentHeader}`}>
            Shipment Info:
          </span>
          <span className={`${styles.headerCell} ${styles.productHeader}`}>
            Product Image:
          </span>
          <div className={styles.summaryHeader}>
            <span className={`${styles.headerCell} ${styles.priceHeader}`}>
              Price:
            </span>
            <span className={`${styles.headerCell} ${styles.statusHeader}`}>
              Order Status:
            </span>
            <span
              className={styles.actionHeader}
              aria-hidden="true"
              role="presentation"
            ></span>
          </div>
        </header>

        <div className={styles.listBody} role="list">
          {hasOrders ? (
            safeOrders.map((order, index) => {
              const key = order?.id ?? order?.orderNum ?? index;
              const orderProps = {
                ...order,
                onView: resolveOnView(order, index),
              };

              return (
                <div className={styles.listRow} role="listitem" key={key}>
                  <OrderHistoryItem {...orderProps} />
                </div>
              );
            })
          ) : (
            <div className={styles.emptyState}>No orders available.</div>
          )}
        </div>
      </div>
    </section>
  );
}

OrderHistoryList.propTypes = {
  orders: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      orderNum: PropTypes.string,
      trackingNum: PropTypes.string,
      placedOn: PropTypes.string,
      expectedDelivery: PropTypes.string,
      numOfItems: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      item: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          name: PropTypes.string,
          description: PropTypes.string,
          image: PropTypes.string,
        })
      ),
      total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      status: PropTypes.string,
      onView: PropTypes.func,
    })
  ),
  onOrderView: PropTypes.func,
};
